import MainImage from '../voluntary-template/icons/Ogpo.png';
import VectorFirst from '../voluntary-template/icons/box/shield.svg';
import VectirSecond from '../voluntary-template/icons/box/list.svg';
import VectorThird from '../voluntary-template/icons/box/info.svg';
import Checkbox from '../voluntary-template/icons/Checkbox.svg';
import Thunder from '../voluntary-template/icons/Thunder.svg';
import Contract from '../voluntary-template/icons/Danger_obj.png';
import Shield from '../voluntary-template/icons/Shield.png';
import Star from '../voluntary-template/icons/Star.png';
import Pyramid from '../voluntary-template/icons/pyramid.png';
import People from '../voluntary-template/icons/people.png';
import Box from '../voluntary-template/icons/Box.png';

const ogpoResources = {
  en: {
    ogpo: {
      title: 'Mandatory Liability Insurance for Hazardous Facility Owners',
      description:
        'Mandatory insurance of civil liability for owners of hazardous facilities. Provides protection of third-party interests in the event of accidents, incidents, or environmental damage.',
      buttonText: 'Submit Application',
      infoCards: [
        {
          title: 'Compliance with Legislation',
          content:
            'The policy fully complies with the laws of the Republic of Kazakhstan.',
        },
        {
          title: 'Compensation for Third-Party Damage',
          content:
            'Covers harm to the health, property, and life of affected individuals.',
        },
        {
          title: 'For All Types of Hazardous Facilities',
          content:
            'Including explosive, fire-hazardous, and environmentally dangerous facilities.',
        },
      ],
      coverage: [
        {
          title: 'What Is Insured',
          content: ['Liability of owners of hazardous industrial facilities'],
        },
        {
          title: 'Covered Risks',
          content: [
            'Harm to life and health of third parties',
            'Damage to property',
            'Environmental harm',
            'Moral damage',
          ],
        },
        {
          title: 'Illustration',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Insurance Amount',
          content:
            'Determined based on the hazard class of the facility, in accordance with legal requirements.',
        },
        {
          title: 'Policy Duration',
          content:
            '1 year. Mandatory extension for the entire operational period.',
        },
        {
          title: 'Territory of Coverage',
          content: 'Entire territory of the Republic of Kazakhstan.',
        },
      ],
      formTitle: 'Insurance Application',
      formDescription:
        'Please be sure to provide the company name, BIN, and contact phone number.',
      formCheckBox1: 'I confirm',
      formCheckBox2:
        'my consent to the collection and processing of personal data',
      formPlaceholder1: 'Company',
      formPlaceholder2: 'BIN',
      formPlaceholder3: 'Full Name',
      formPlaceholder4: 'Phone',
      formPlaceholder5: 'Email',
      formPlaceholder6: 'Comment',
      formButtonText: 'Submit Application',
      formSuccessStatus: 'Your application has been submitted successfully.',
      formErrorStatus: 'Failed to submit the application.',
      formErrorMessage:
        'Please try submitting the application again in 4 hours.',
      formSendClose: 'Close',
      trustTitle: 'Why clients trust Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 years',
            content: 'on the insurance market of Kazakhstan',
          },
          {
            id: 2,
            title: 'TOP 2',
            content: 'by volume of insurance payouts',
          },
          {
            id: 3,
            title: 'kzA-',
            content: 'financial stability rating by S&P Global Ratings',
          },
          {
            id: 4,
            title: '600+',
            content: 'employees working across the country',
          },
        ],
        second: [
          {
            id: 5,
            title: '₸59.4 billion',
            content: 'insurance premiums collected in 2024',
          },
          {
            id: 6,
            title: '₸22 billion',
            content: 'insurance payouts made in 2024',
          },
        ],
        third: '(According to the National Bank of Kazakhstan, Jan–Feb 2025)',
      },
    },
  },
  kz: {
    ogpo: {
      title: 'Қауіпті объектілер иелерінің АҚЖМС',
      description:
        'Үшінші тұлғаларға зиян келтіру қаупімен байланысты қауіпті объектілер иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру.',
      buttonText: 'Өтініш беру',
      infoCards: [
        {
          title: 'Сақтандыру не үшін қажет',
          content:
            'Қауіпті өндірістік фактор келтірген залал үшін үшінші тұлғалардың өмірін, денсаулығын және (немесе) мүлкін қорғауды қамтамасыз ету мақсатында. Бұл түр сақтандырудың міндетті түрлеріне жатады.',
        },
        {
          title: 'Дербес талаптар',
          content: 'Қазақстан Республикасындағы заңнама талаптарына сәйкес.',
        },
        {
          title:
            'Объектілер иелерінің жауапкершілігін сақтандырудың негізгі қағидаттары',
          content:
            'Заңда белгіленген көлемде және тәртіппен үшінші тұлғалардың мүліктік мүдделерін қорғауды қамтамасыз ету және тараптардың объектілер иелерінің жауапкершілігін міндетті сақтандыру шарты бойынша өз міндеттемелерін орындауын қамтамасыз ету.',
        },
      ],
      coverage: [
        {
          title: 'Нені сақтандырамыз',
          content: [
            '"Азаматтық қорғау туралы" Қазақстан Республикасының Заңына сәйкес өнеркәсіптік қауіпсіздікті декларациялауға жататын объектілер.',
          ],
        },
        {
          title: 'Қандай тәуекелдерден',
          content: [
            'Сақтанушының (сақтандырылушының) үшінші тұлғаның өміріне, денсаулығына және (немесе) мүлкіне келтірілген зиянды өтеу жөніндегі азаматтық-құқықтық жауапкершілігінің басталу фактісі қауіпті өндірістік фактор болып танылады.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Сақтандыру сомасы',
          content:
            'ҚР заңнамасының талаптарына сәйкес қауіпті өндірістік факторлардың зиянды әсерінен зардап шеккендердің барынша көп санына байланысты АЕК-те есептеледі.',
        },
        {
          title: 'Қолданыс мерзімі',
          content: '12 ай.',
        },
        {
          title: 'Сақтандыру аумағы',
          content: 'Қазақстан Республикасы.',
        },
      ],
      formTitle: 'Өтінім қалдыру',
      formDescription: 'БСН және байланыс телефонын көрсетуді ұмытпаңыз.',
      formCheckBox1: 'Мен',
      formCheckBox2:
        'жеке деректерімді жинауға және өңдеуге келісімімді растаймын',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БСН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.пошта',
      formPlaceholder6: 'Түсініктеме',
      formButtonText: 'Жөнелту',
      formSuccessStatus: 'Сіздің өтінішіңіз сәтті жіберілді.',
      formErrorStatus: 'Өтінішті жіберу сәтсіз аяқталды.',
      formErrorMessage: 'Өтінішті 4 сағаттан кейін жіберіп көріңіз.',
      formSendClose: 'Жабу',
      trustTitle: 'Неліктен клиенттер Alatau City Garant-қа сенім артады',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 жыл',
            content: 'Қазақстанның сақтандыру нарығында қызмет еткеніне',
          },
          {
            id: 2,
            title: '3 орын',
            content:
              '2024 жылы ҚР жалпы сақтандыру компаниялары арасында сақтандыру төлемдерінің көлемі бойынша',
          },
          {
            id: 3,
            title: 'ВВ-Болжам «Тұрақты»',
            content: 'S&P Global Ratings қаржылық тұрақтылық рейтингі',
          },
          {
            id: 4,
            title: '15 филиал',
            content: 'Alatau City Garant бүкіл ел аумағында жұмыс істейді',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content:
              'сақтандыру сыйлықақыларын Alatau City Garant 2024 жылы жинады',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'Alatau City Garant 2024 жылы клиенттерге төледі',
          },
        ],
        third: '(ҚР Ұлттық Банкінің деректері бойынша)',
      },
      businessDescription:
        'Қауіпті объектілер иелерінің азаматтық-құқықтық жауапкершілігін міндетті сақтандыру.',
    },
  },
  ru: {
    ogpo: {
      title: 'ОСГПО владельцев опасных объектов',
      description:
        'Обязательное страхование гражданско-правовой ответственности владельцев опасных объектов, объектов деятельность которых связана с опасностью причинения вреда третьим лицам.',
      buttonText: 'Отправить заявку',
      infoCards: [
        {
          title: 'Для чего нужна страховка',
          content:
            'Для обеспечения защиты жизни, здоровью и (или) имуществу третьих лиц за ущерб, причиненный опасным производственным фактором. Данный вид относится к обязательным видам страхования.',
        },
        {
          title: 'Условия страхования',
          content:
            'В соответствии с требованиями законодательства  в Республике Казахстан.',
        },
        {
          title:
            'Основные принципы страхования ответственности владельцев объектов',
          content:
            'Обеспечение защиты имущественных интересов третьих лиц в объеме и порядке, установленных Законом и обеспечение исполнения сторонами своих обязательств по договору обязательного страхования ответственности владельцев объектов.',
        },
      ],
      coverage: [
        {
          title: 'Что страхуем',
          content: [
            'Объекты, подлежащие декларированию промышленной безопасности в соответствии с Законом Республики Казахстан «О гражданской защите».',
          ],
        },
        {
          title: 'От каких рисков',
          content: [
            'Страховым случаем признается  факт наступления гражданско-правовой ответственности Страхователя (Застрахованного) по возмещению вреда, причиненного жизни, здоровью и (или) имуществу третьего лица опасным производственным фактором.',
          ],
        },
        {
          title: 'Иллюстрация',
          content: [],
        },
      ],
      featureCards: [
        {
          title: 'Страховая сумма',
          content:
            'В соответствии с требованиями законодательства в РК, рассчитывается в МРП в зависимости от максимально возможного числа потерпевших в результате вредного воздействия опасных производственных факторов.',
        },
        {
          title: 'Срок действия',
          content: '12 месяцев.',
        },
        {
          title: 'Территория страхования',
          content: 'Республики Казахстан.',
        },
      ],
      formTitle: 'Заявка на страхование',
      formDescription:
        'Пожалуйста, обязательно укажите БИН и контактный телефон.',
      formCheckBox1: 'Я подтверждаю ',
      formCheckBox2: 'согласие на сбор и обработку персональных данных',
      formPlaceholder1: 'Компания',
      formPlaceholder2: 'БИН',
      formPlaceholder3: 'ФИО',
      formPlaceholder4: 'Телефон',
      formPlaceholder5: 'Эл.почта',
      formPlaceholder6: 'Комментарий',
      formButtonText: 'Отправить заявку',
      formSuccessStatus: 'Спасибо! Ваша заявка отправлена',
      formErrorStatus: 'Не удалось отправить заявку',
      formErrorMessage: 'Попробуйте отправить заявку через 4 часа.',
      formSendClose: 'Закрыть',
      trustTitle: 'Почему клиенты доверяют Alatau City Garant',
      trustCards: {
        first: [
          {
            id: 1,
            title: '17 лет',
            content: 'на страховом рынке Казахстана',
          },
          {
            id: 2,
            title: '3 место',
            content:
              'по объему страховых выплат среди компаний общего страхования РК в 2024 году',
          },
          {
            id: 3,
            title: 'ВВ-прогноз «Стабильный»',
            content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
          },
          {
            id: 4,
            title: '15 филиалов',
            content: 'Alatau City Garant работают по всей стране ',
          },
        ],
        second: [
          {
            id: 5,
            title: '39,3 млрд ₸',
            content: 'страховых премий собрал Alatau City Garant в 2024 году',
          },
          {
            id: 6,
            title: '25,5 млрд ₸ ',
            content: 'выплатил Alatau City Garant клиентам в 2024 году ',
          },
        ],
        third: '(по данным Нацбанка РК)',
      },
      businessDescription:
        'Обязательное страхование гражданско-правовой ответственности владельцев опасных объектов.',
    },
  },

  mainCard: {
    image: MainImage,
  },
  infoCards: [
    {
      id: 1,
      image: VectorFirst,
    },
    {
      id: 2,
      image: VectirSecond,
    },
    {
      id: 3,
      image: VectorThird,
    },
  ],
  coverage: [
    {
      title: 'Что страхуем?',
      content: [
        'Объекты, подлежащие декларированию промышленной безопасности в соответствии с Законом Республики Казахстан «О гражданской защите».',
      ],
      image: Checkbox,
    },
    {
      title: 'От каких рисков?',
      content: [
        'Страховым случаем признается  факт наступления гражданско-правовой ответственности Страхователя (Застрахованного) по возмещению вреда, причиненного жизни, здоровью и (или) имуществу третьего лица опасным производственным фактором',
      ],
      image: Thunder,
    },
    {
      title: 'Иллюстрация',
      content: [],
      image: Contract,
    },
  ],
  featureCards: [
    {
      title: 'Страховая сумма',
      content:
        'Определяется по классу опасности объекта, согласно требованиям законодательства.',
    },
    {
      title: 'Срок действия',
      content: '1 год. Обязательно продлевается на весь период эксплуатации.',
    },
    {
      title: 'Территория действия',
      content: 'Вся территория Республики Казахстан.',
    },
  ],
  trustCards: {
    first: [
      {
        id: 1,
        title: '17 лет',
        content: 'на страховом рынке Казахстана',
        image: Shield,
      },
      {
        id: 2,
        title: 'ТОП 2',
        content: 'по объёму страховых выплат ',
        image: Star,
      },
      {
        id: 3,
        title: 'kzA-',
        content: 'рейтинг финансовой устойчивости от S&P Global Ratings',
        image: Pyramid,
      },
      {
        id: 4,
        title: '600+',
        content: 'сотрудников работают по всей стране',
        image: People,
      },
    ],
    second: [
      {
        title: '59,4 млрд ₸',
        content: 'страховых премий собрано за 2024 год ',
      },
      {
        title: '22 млрд ₸',
        content: 'выплачено по страховым случаям за 2024 год',
      },
    ],
    image: Box,
  },
};

export default ogpoResources;
